import { render, staticRenderFns } from "./PartnershipPostShow.vue?vue&type=template&id=7f9c8b1c&scoped=true&"
import script from "./PartnershipPostShow.vue?vue&type=script&lang=js&"
export * from "./PartnershipPostShow.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipPostShow.vue?vue&type=style&index=0&id=7f9c8b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c8b1c",
  null
  
)

export default component.exports